export default {
      id: "tasks-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#tasks-usage",
      toString: function () {
        return this.url;
      }
    }